import { AxiosInstance } from 'axios';
import axios from 'axios';
import { IUser } from '../interfaces/IUser';
import { CrudService } from './crudService';
import { IChangeCompanyResponse } from '../interfaces/IChangeCompanyResponse';

export class UserService extends CrudService<IUser> {

    constructor(apiClient: AxiosInstance) {
        super(apiClient, '/admin/users');
    }

    async changeCompany(companyid: string): Promise<IChangeCompanyResponse> {
        try {
            const response = await this.apiClient.post(`${this.endpoint}/change-company`, { companyid });
            return response.data as IChangeCompanyResponse;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async addCompany(companyName: string): Promise<IChangeCompanyResponse> {
        try {
            const response = await this.apiClient.post(`${this.endpoint}/add-company`, { companyName });
            return response.data as IChangeCompanyResponse;
        } catch (error: unknown) {
            if (axios.isAxiosError(error) && typeof error.response?.data === 'string') {
                throw new Error(error.response.data);
            }
            throw new Error('An error occurred');
        }
    }
}